export default __webpack_public_path__ + "static/media/salesRetail.836f581d.PNG";